<template>
  <div>
    <router-link :to="login">Log in</router-link>
  </div>
</template>

<script>
  export default {
  
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/users/ForgottenPassword.vue